import * as yup from "yup";

export const validations = {
  idTipoDireccion: yup
    .string()
    .required("Campo requerido"),
  idTipoVivienda: yup
    .string()
    .required("Campo requerido"),
  barrioComunidad: yup
    .string()
    .required("Campo requerido"),
  direccion: yup
    .string()
    .required("Campo requerido"),
  referencia: yup
    .string()
    .required("Campo requerido"),
  sector: yup
    .string()
    .required("Campo requerido"),
  idTipoDireccionTrabajo: yup
    .string()
    .required("Campo requerido"),
  barrioComunidadTrabajo: yup
    .string()
    .required("Campo requerido"),
  direccionTrabajo: yup
    .string()
    .required("Campo requerido"),
  referenciaTrabajo: yup
    .string()
    .required("Campo requerido"),
  sectorTrabajo: yup
    .string()
    .required("Campo requerido"),
};
